let language = {
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE: "验证错误",
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE_CONTENT_1: "牌的总数必须等于牌包中的牌的总数，并且所有的数量必须是非负的。",
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE_CONTENT_2: "概率值必须在0到100之间。 ",
    RANDOM_DESIGN_EDITER_INFO_VALIDATE_TITLE_CONTENT_3: "请完成所有图片库配置：选择一个图片库并设置概率，并且图片库必须上传最少一张图片。",

}
export { language }